import { GlassIcon, InspectionIcon, MiscIcon, WheelchangeIcon } from "@App/Components/common/Icons";
import type { ReactNode } from "react";

/**
 * Maps a service's `pivot.icon` to its icon component. Anything unmapped falls back to `MiscIcon`,
 * so whitelabels with many services will show repetition until icons are drawn for them.
 */
export const getServiceIcon = (name?: string): ReactNode => {
  const icons: Record<string, ReactNode> = {
    Inspection: <InspectionIcon />,
    Wheelchange: <WheelchangeIcon />,
    Glas: <GlassIcon />,
    Misc: <MiscIcon />,
  };

  return icons[name ?? "Misc"] ?? <MiscIcon />;
};
